import React from 'react';

interface AiIconProps {
	color?: string;
	size?: number;
}

// Classic AI "sparkle": one large and one small four-pointed star
const AiSparkleIcon: React.FC<AiIconProps> = ({color = '#001B74', size = 16}) => {
	return (
		<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M6.5 2L7.7 5.8L11.5 7L7.7 8.2L6.5 12L5.3 8.2L1.5 7L5.3 5.8L6.5 2Z" fill={color}/>
			<path d="M12.5 9.5L13.1 11.4L15 12L13.1 12.6L12.5 14.5L11.9 12.6L10 12L11.9 11.4L12.5 9.5Z" fill={color}/>
			<path d="M12.5 1L12.9 2.1L14 2.5L12.9 2.9L12.5 4L12.1 2.9L11 2.5L12.1 2.1L12.5 1Z" fill={color} fillOpacity="0.6"/>
		</svg>
	);
};

export default AiSparkleIcon;
